'use strict';
angular.module('atex.dam').factory("CollectionService", ['$q', '$rootScope', '$modal', '$log', 'ContentService', 'SearchService', 'AuthenticationService', 'DamService',
function($q, $rootScope, $modal, $log, ContentService, SearchService, AuthenticationService, DamService) {
  function CollectionService( ) {
  }
  var selected=[];
  var dirty = false;
  CollectionService.getSelected = function() {
    return selected;
  };

  CollectionService.clearSelection = function()  {
    selected.length = 0;
  };

  CollectionService.getDirty = function() {
    return dirty;
  };

  CollectionService.setDirty = function(bVal)  {
    dirty = bVal;
  };

  //rest api js interface
  //var collectionSecParentId = "dam.assets.common.d";

  CollectionService.createCollectionUI = function(contents, collectionName) {
    var deferred = $q.defer();
    if (!collectionName) {
      var modalScope = $rootScope.$new(true);
      var modal = $modal({
        show: true,
        scope: modalScope,
        template: 'views/dam-collection-name.html',
        backdrop: false,
        windowClass: 'modal'
      });
      var destroyModal = function() {
        modal.then(function(modalEl) {
          modalEl.on('hidden.bs.modal', function() {
            modalScope.$destroy();
          });
          modalEl.modal('hide');
        });
      };
      modalScope.doCancel = function() {
        destroyModal();
        deferred.reject();
      };
      modalScope.doOk = function() {
        destroyModal();
        CollectionService.createCollection(modalScope.collectionName, contents).then(function(response) {
          deferred.resolve(response);
        }).then(null, function(error) {
          deferred.reject(error);
        });
      };
    } else {
      CollectionService.createCollection(collectionName, contents).then(function(response) {
        deferred.resolve(response);
      }).then(null, function(error) {
        deferred.reject(error);
      });
    }

    return deferred.promise;
  };

  CollectionService.createCollection = function (name, contents) {
    return AuthenticationService.callWithAuthentication(function (currentUser) {
      var arrayLength = contents.length;
      if (name === undefined || contents === undefined) {
        return $q.reject();
      }

      var idsArray = [];
      for (var i = 0; i < arrayLength; i++) {
        idsArray.push(contents[i].id);
      }

      var createTransferInfo = {
        data: {
          aspects: {
            contentData: {
              data: {
                _type: 'atex.dam.standard.Collection',
                name: name,
                contents: idsArray
              }
            },
            /*'p.InsertionInfo': {
              data: {
                _type: 'p.InsertionInfo',
                securityParentId: 'externalid/' + collectionSecParentId
              }
            },*/
            'atex.dam.standard.ContentAccess': {
              data: {
                _type: 'atex.dam.standard.ContentAccess',
                "assignees": [
                  {
                    "externalId": currentUser.principalId,
                    "owner": true
                  }
                ],
                "creator": currentUser.principalId
              }
            },
            'atex.Metadata': {
              data : {
                _type: 'atex.Metadata',
                taxonomyIds : [
                  'p.StandardCategorization'
                ],
                metadata:{

                }
              }
            }
          }
        }
      };

      return ContentService.createContent(createTransferInfo).then(function (response) {
        return ContentService.getContent({id: response.id}).then(function (collection) {
          console.log('INFO: Created collection: ', collection.id);
          return collection;
        });
      });
    });
  };

  CollectionService.updateCollection = function (collection, contents, skipContents) {
    if (collection === undefined || contents === undefined) {
      return $q.reject();
    }
    if (!skipContents) {
      var idsArray = [];
      var arrayLength = contents.length;
      for (var i = 0; i < arrayLength; i++) {
        idsArray.push(atex.dam.AngularUtils.addPrefix(contents[i].id));
      }
      collection.data.aspects.contentData.data.contents = idsArray;
      delete collection.data.aspects.contentData.data['contents_element_types'];
    }

    var json = angular.toJson(collection);
    var cleanCollection = angular.fromJson(json);

    var updateTransferInfo = {
      id: cleanCollection.id,
      revision: cleanCollection.revision,
      data : {
        aspects : cleanCollection.data.aspects
      }
    };

    return ContentService.updateContent(updateTransferInfo).then(function (response) {
      return ContentService.getContent({id: response.id}).then(function (collection) {
        return collection;
      });
    });
  };

  CollectionService.deleteCollection = function (id) {
    return this.getCollection(id).then(function (collection) {
      return ContentService.deleteContent({id: collection.id, revision: collection.revision}).then(function () {
        return collection;
      });
    });
  };

  CollectionService.getAllCollectionsData = function (name, options) {
    return DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
      return DamService.getSolrServerInfo().then(function (solrInfo) {
        var transferInfo = {};
        transferInfo['core'] = solrInfo.solrCore;
        transferInfo['variant'] = 'list';
        transferInfo['q'] = '+type:(atex.dam.standard.Collection)';
        if (currentUserInfo && !currentUserInfo.isAdm) {
          transferInfo['q'] += '+assignees_atex_desk_sms:(';
          transferInfo['q'] += currentUserInfo.externalId;
          for (var i = 0; currentUserInfo.groups && i < currentUserInfo.groups.length; i++) {
            var escaped = currentUserInfo.groups[i].principalId.replace(':', '\\:');
            transferInfo['q'] += ' OR ' + escaped;
          }
          transferInfo['q'] += ')';
        }
        if (name) {
          transferInfo['q'] += '+name_atex_desk_ts:(*' + name + '*)';
        }
        if (options) {
          transferInfo = _.extend(transferInfo, options);
        } else {
          transferInfo['rows'] = '10';
        }
        return SearchService.search(transferInfo).then(function (response) {
          if (response.data.response.docs) {
            var collectionsPromises = response.data.response.docs.map(function (item) {
              return ContentService.getContent({id: item.id});
            });
            return $q.all(collectionsPromises);
          }
        });
      });
    });
  };

  CollectionService.getCollection = function (id) {
    return ContentService.getContent({id: id});
  };

  CollectionService.getAllCollectionItems = function(collection) {
    var contents = atex.onecms.ObjectUtils.getByPath(collection, 'data/aspects/contentData/data/contents');
    if(!contents) {
      contents = atex.onecms.ObjectUtils.getByPath(collection, 'data/aspects/contentData/data/resources');
    }

    var itemsPromises = contents.map(function(item) {
      item = atex.dam.AngularUtils.removePrefix(item);
      return ContentService.getContent({ id: item}).then(function(responseInfo) {
        atex.dam.AngularUtils.fixUrls(responseInfo.data);
        return responseInfo;
      }).then(null, function(error) {
        if (!error.rootCause || error.rootCause.status!==403) {
          console.log('ERROR: Getting content:', error);
          return undefined;
        }
        var forbiddenItem = {
            id: item,
            data : {
              aspects : {
                contentData : {
                  data : {
                    thumbUrl : "img/prohibited.png"
                  }
                }
              }
            },
            isForbidden : true,
            dontShow : !window.atex.dam.cfg.showCollectionForbiddenItems
        };
        return forbiddenItem;
      });
    });
    return $q.all(itemsPromises).then(function(itemsResults) {
      return itemsResults;
    });
  };

  CollectionService.getCollectionChildsIDs = function (collectionId) {
    return ContentService.getContent({id: collectionId}).then(function (collection) {
      var IDs = [];
      var contents = atex.onecms.ObjectUtils.getByPath(collection, 'data/aspects/contentData/data/contents');
      if (contents) {
        contents.forEach(function(contentId){
          IDs.push(atex.dam.AngularUtils.removePrefix(contentId));
        });
      }
      return IDs;
    });
  };

  CollectionService.prototype = {
    constructor: CollectionService
  };

  return(CollectionService);
}]);
